import * as React from "react";
import { DateUtils } from "@grandvisionhq/utils";
const useShouldRequestAlternativeStoreSuggestions = (timeSlots, selectedData, selectedStore, timeSlotsMetadata) => React.useMemo(() => {
  const dateString = selectedData ? DateUtils.toLocalDateTime(selectedData) : "";
  const timeSlotsLoaded = timeSlots.called && !timeSlots.loading;
  const noTimeSlots = !(timeSlots.filtered.included.length > 0);
  const noOtherTimeSlots = !(timeSlots.filtered.excluded.length > 0);
  const timeslotsReferToSelectedDate = timeSlotsMetadata?.timeSlotsReferTo.date?.split("T")[0] === dateString.split("T")[0];
  const timeslotsReferToSelectedStore = timeSlotsMetadata?.timeSlotsReferTo.store === selectedStore?.globalStoreId;
  return timeSlotsLoaded && timeslotsReferToSelectedDate && timeslotsReferToSelectedStore && noTimeSlots && noOtherTimeSlots;
}, [
  selectedData,
  selectedStore?.globalStoreId,
  timeSlots.called,
  timeSlots.filtered,
  timeSlots.loading,
  timeSlotsMetadata?.timeSlotsReferTo.date,
  timeSlotsMetadata?.timeSlotsReferTo.store
]);
export {
  useShouldRequestAlternativeStoreSuggestions as default
};
//# sourceMappingURL=useShouldRequestAlternativeStoreSuggestions.js.map
